import Cookies from 'universal-cookie';
import axios from 'axios'
import apiConfig from './config/api';

const API_BASE = apiConfig.baseUrl;

const cookies = new Cookies();
let glob_token = "";

// APIIsLoggedOn - moved to top to fix initialization order
export const APIIsLoggedOn = async (payload) => {
  if(typeof payload === "undefined" || (payload.token??"") == "") {
    console.log('payload is undefined or payload.token is empty')
    return
  }

  glob_token = payload.token
  try {
    let resp = await fetch(API_BASE + "/users/" + payload.id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': payload.token ? 'Bearer ' + payload.token : null
      }
    })
    return await resp.json()

  }catch(err){
    return {error: 'Not Logged In'}
  }
}

// APIloggedin - moved to top to fix initialization order
export const APIloggedin = async () => {
  const flgcookie = cookies.get('wos_lo');
  if(typeof flgcookie !== "undefined"  && flgcookie.id && flgcookie.token) {
      try{
          const logondata = await APIIsLoggedOn(flgcookie)
          if(typeof logondata !== "undefined" &&  logondata._id === flgcookie.id) {
              glob_token = flgcookie.token
              return {status: true, loggedon: true, token:  flgcookie.token, userid: logondata["_id"], admin: logondata.admin, manager: logondata.manager, rep_name: flgcookie.rep_name, rep_email: flgcookie.rep_email   }
          }
          return {status: true, loggedon: false, token:  flgcookie.token, userid: logondata["_id"], admin: logondata.admin, manager: logondata.manager, rep_name: flgcookie.rep_name, rep_email: flgcookie.rep_email, logondata   }
        }catch(err) {
          console.log(err)
          return {status: false, loggedon: false, rep_name: '', rep_email: '', manager: false, admin: false}
      }
  }
  else {
    return {status: false, loggedon: false, rep_name: '', rep_email: '', manager: false, admin: false}
  }
}

const returnGet = async (getstring) => {
  // Make sure we have a refreshed update of our Bearer token
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()

  return await fetch(getstring,{
    method:   'GET',
    headers:  { 
                'Accept': '*/*',
                'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null 
              },
  })
}

export const getSolarSavigsFromServer = async (payload,action) => {
    try {
        // Make our initial Fetch Call to the Server (now uses Node.js endpoint)
        const resp = await fetch(API_BASE + "/sao", {
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action: action,
                payload: payload,
            }),

        })
        var json = {}
        if(resp.ok)
          json = await resp.json()

        return json;
    }catch(err){
      console.log("Api.js - getSolarSavigsFromServer")
        console.log(err);
        console.log(payload);
        return err;
    }

  }

  export const webLogonServer = async (payload) => {
    try {
        // Make our initial Fetch Call to the Server (now uses Node.js endpoint)
        const resp = await fetch(API_BASE + "/sao", {
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                payload: payload,
                action: 'WebLogon'
            }),

        })
        var json  = await (resp.ok && resp.json())
        return json;
    }catch(err){
        console.log("Api.js - webLogonServer")
        console.log(err);
        return err;
    }

  }

  export const getMapKey = async (payload) => {
    try {
        // Make our initial Fetch Call to the Server (now uses Node.js endpoint)
        const resp = await fetch(API_BASE + "/sao", {
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action: 'GetMapKey',
                payload: payload,
            }),

        })
        var json  = await (resp.ok && resp.json())
        return json;
    }catch(err){
      console.log("Api.js - getMapKey")
        return err;
    }

  }


  
  export const GetBatterys = async () => {
    const response = await returnGet(API_BASE + "/battery")
    if(!response.ok) return null;

    const batteries = await response.json()
    return batteries;
  }

  GetBatterys().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("GetBatterys - " + error.message);
  });

  export const APIGetAllACControllers = async () => {
    const response = await returnGet(API_BASE + "/accontroller")
    if(!response.ok) return null;
    const accontrollers = await response.json()
    return accontrollers;
  }

  APIGetAllACControllers().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("APIGetAllACControllers - " + error.message);
  });

  export const GetTariffs = async () => {
    const response = await returnGet(API_BASE + "/tariff")
    if(!response.ok ) {
        return null;
    }
    const tariffs = await response.json()
    return tariffs
  }

  GetTariffs().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("GetTariffs - " + error.message);
  });

  // Get Panels
  export const GetPanels= async () => {
    const response = await returnGet(API_BASE + "/panel")
    const panels = await response.json()
    return panels
  }

  GetPanels().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("GetPanels - " + error.message);
  });
  
  export const getFinanceRates = async () => {
    const response = await returnGet(API_BASE + "/financerate")
    if(!response.ok) {
        return null;
    }
    const finance_rates = await response.json()
    return finance_rates;
  }

  getFinanceRates().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("getFinanceRates - " + error.message);
    return {}
  });

    // Get Installation Areas (Eg Roof type, Ground etc )
    export const GetInstallationLocations = async () => {
    const response = await returnGet(API_BASE + "/installationareas")
    if(!response.ok) { return null; }
    const installation_areas = await response.json()
    return installation_areas;
  }

  GetInstallationLocations().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("getInstallationAreas - " + error.message);
    return {}
  });



// Get Maintenance Options
    export const GetMaintenanceOptions = async () => {

   // Make sure we are still logged in.  
    const response = await returnGet(API_BASE + "/maintenanceoptions")
    if(!response.ok) {
        return null;
    }
    const maintenance_options = await response.json()
    return maintenance_options;
  }

  GetMaintenanceOptions().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("GetMaintenanceOptions - " + error.message);
    return [{maintenance_id: 0, description: 'None'}]
  });

  // Get FLG Details
  export const GetFlgFromID = async (id,payload = {token: ''}) => {
    if(!id || typeof id === "undefined" )
      return;
      
    if(payload.token == "") {
      await APIloggedin()
      payload.token = glob_token
    }

    const response = await returnGet(API_BASE + "/flg/" + id)
    if(!response.ok ) {
        return null;
    }
    const flg = await response.json()
    return flg
  }
  
  GetFlgFromID().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Get FLG Record from ID: - " + error.message);
    return {}
  });

  // CheckFLGID is valid
  export const  APICheckFlgID = async (id,payload = {token: ''}) => {
    if(!id || typeof id === "undefined" )
      return;
      
    if(payload.token == "") {
      APIloggedin()
      payload.token = glob_token
    }

    const response = await fetch(API_BASE + "/checkflg/" + id,
    {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + payload.token
      }
    })
    if(!response.ok ) {return {status: false, flg: null};}
    const flg = await response.json()
    return {...flg}
  }
  
  APICheckFlgID().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Check FLG ID: - " + error.message);
    return {status: false, flg: null}
  });

  export const UpdateFLG = async (payload) => {
    // payload is the state object passed in
    if(!payload)
      return
    const id = payload.id
    if(!id || typeof id === "undefined" )
      return;
    delete payload["flg_id"];
    var pl = {}
    try {
      pl = JSON.stringify(payload)
    }catch(err) {
      console.log("Error Stringify payload")
      console.log(payload)
    }
    if(typeof glob_token == "undefined" || glob_token == "")
      await APIloggedin()


    return fetch(API_BASE + "/flg/" + id, {
      method: 'PUT',
      headers: {  'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null },
      body: pl
    }).then(response => response.json())
  }

  UpdateFLG().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Get FLG Record from ID: - " + error.message);
    return {}
  });

  export const APILogon = async(payload) => {
    if(typeof payload === "undefined" ) return
    let response = await fetch(API_BASE + "/auth/signin" , {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    return await response.json()
  } 

  APILogon().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error Logging on: - " + error.message);
    return {}
  });

  // APIIsLoggedOn moved to top of file

  // Get Presnter Slides 
  export const APIGetPresenterSlides = async (flg_id) => {
    if(typeof flg_id === "undefined") return
    try{ 
      const response = await returnGet(API_BASE + "/presenterslides/" + flg_id)
      if(!response.ok) {
          return null;
      }
      const presenterslides = await response.json()
      return presenterslides;
    }catch(err) {
      console.log("error in APIGetPresenterSlides")
      console.log(err)
      return null
    }
  }

  APIGetPresenterSlides().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("APIGetPresenterSlides - " + error.message);
    return {}
  });
  
  // Write HTML data to a file so we can convert to PDF
  export const APICreateDataSheets = async (flg_id, payload, html_file, pdf_file, format) => {

    if(typeof payload === "undefined") return
    try {
      let response = await fetch(API_BASE + '/datasheets/', {
        method: 'POST',
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
          'Authorization': glob_token ? 'Bearer ' + glob_token : null,
        },
        body: JSON.stringify({
          flg_id,
          html: payload,
          html_file,
          pdf_file,
          format
        })
      })
      return await response.json()
    }catch(err) {
      console.log('APIFileWriter error: ' + err)
      return {error: 'APIFileWriter error: ' + err} 
    }
  }

  APICreateDataSheets().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error Checking filewriter: - " + error.message);
    return {}
  });

  // Get a PDF File
  export const APIGetpdf = async(file) => {
    if(typeof file === "undefined" ) return
    const response = await fetch(API_BASE + "/presenterslides" , {
      method: 'POST',
      headers: {  'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null
    },
      body: JSON.stringify({file: file})
    })
    const blob = await response.blob();
    const data = await blob.arrayBuffer()
    return data
  } 

  APIGetpdf().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error Checking filewriter: - " + error.message);
    return {}
  });


  export const APIMailMerge = async(flg_id,slide_id, payload) => {

    if(typeof flg_id === "undefined") return 
    if(typeof slide_id === "undefined" || slide_id === 0)  return
    await fetch(API_BASE + "/pdfMerge/" + flg_id , {
      method: 'POST',
      headers: {  'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null },
      body: JSON.stringify({slide_id,payload })
    })

    return
  } 

  APIMailMerge().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error with pdfMerge: - " + error.message);
    return {}
  });


  export const APIMergeFiles = async(flg_id,slides,version) => {
    if(typeof flg_id === "undefined") return;
    if(typeof slides === "undefined") return
    await await fetch(API_BASE + "/MergeFiles/" + flg_id , {
      method: 'POST',
      headers:  { 'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null 
                },
      body: JSON.stringify({slides, version })
    })
    return
  } 

  APIMergeFiles().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error with pdfMerge: - " + error.message);
    return {}
  });

  export const APIMergeOrderForm = async(flg_id,data, filelist,norate=false, batteryonly=false,offgrid_system=false) => {
    if(typeof flg_id === "undefined") return;
    if(typeof data === "undefined") return
    await fetch(API_BASE + "/MergeOrderForm/" + flg_id , {
      method: 'POST',
      headers:  { 'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null
                },
      body: JSON.stringify({data, filelist, norate, batteryonly, offgrid_system })
    })
    return
 
  }
  APIMergeOrderForm().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error with MergeOrderForm: - " + error.message);
    return {}
  });

  export const APIGetJSONMappings = async () => {
    const response = await returnGet(API_BASE + "/GetJSONMappings")
    const json = await response.json();
    return json
  }

  APIGetJSONMappings().catch(error => {
    //error.message; // 'An error has occurred: 404'
    console.log("Error with pdfMerge: - " + error.message);
    return {}
  });


  // APIloggedin moved to top of file

export const APIUploadData = async (flg_id,filelist, progress, complete) => {
  try {
    const data = new FormData() 
    data.append('flg_id',flg_id)
    for(var x = 0; x<filelist.length; x++) {
      data.append('file', filelist[x])
    }
    axios.post( API_BASE + "/picupload/" + flg_id, 
      data, {
        onUploadProgress: ProgressEvent => {
        progress( (ProgressEvent.loaded / ProgressEvent.total*100))
      },
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': glob_token ? 'Bearer ' + glob_token : null
      }
    })
      .then(res => { // then print response status
        complete({status: true, error: ''})
      })
      .catch(err => { // then print response status
        complete({status: false, error: 'Upload failed! ' + err}) 
    })
  }catch(err) {
    complete({status: false, error: 'Upload failed! ' + err})
  }

}

export const APIImageMerge = async(flg_id,slide_id, filelist) => {   
if(typeof flg_id === "undefined") return 
  if(typeof slide_id === "undefined" || slide_id === 0)  return
  await fetch(API_BASE + "/MergeImages/" + flg_id , {
    method: 'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null 
              },
    body: JSON.stringify({slide_id,filelist })
  })
  return
} 

APIImageMerge().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("Error with APIImageMerge: - " + error.message);
  return {}
});


export const APIQuoteUpdate = async(flg_id,site_id, st, pr) => {
  if(typeof flg_id === "undefined") return 
  
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()

  const ret = await fetch(API_BASE + "/quotes/" + flg_id , {
    method: 'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null 
              },
    body: JSON.stringify({site_id, state: st,props: pr })
  })
  return ret
} 

APIQuoteUpdate().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("Error with APIQuoteUpdate: - " + error.message);
  return {}
});

export const APIGetAgreementVersion = async (payload) => {
  if(typeof payload == "undefined") return null;
  if(payload.flg_id <=0 ) return null;
  
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()
  let url = API_BASE + "/GetAgreementVersion"
  url += `?&flg_id=${payload.flg_id}&site_id=${payload.site_id??0}`
  console.log(`APIGetAgreementVersion ${url}`)
  try{
    const response = await fetch(url , {
      method: 'GET',  
      headers:  { 'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null
                }
    })
    if(response.ok && response.status == 200) {
      const ret = await response.json()
      return ret
    }
    else  {
      return response
    }

  }catch(exception) {
    console.log("error in APIGetAgreementVersion")
    console.log(exception)
    return null
  }
}

APIGetAgreementVersion().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("Error with APIGetAgreementVersion: - " + error.message);
  return {}
});

export const APIAddAgreementVersion = async(payload) => {
  if(typeof payload == "undefined") return null;
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()
  try{
    const response = await fetch(API_BASE + "/CreateAdobeAgreement" , {
      method: 'POST',  
      headers:  { 'Content-Type': 'application/json',
                  'Authorization': glob_token ? 'Bearer ' + glob_token : null   
                },
      body: JSON.stringify(payload)
    })

    if(response.ok && response.status == 200) 
      return await response.json()
    else  
      return response

  }catch(exception) {
    console.log("error in APIAddAgreementVersion")
    console.log(exception)
    return null
  }
  
}

APIAddAgreementVersion().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("Error with APIAddAgreementVersion: - " + error.message);
  return {}
});



export const APIGetQuotes = async(flg_id) => {
    
  if(typeof flg_id === "undefined") return 
  
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()
  try{
    
    const response = await returnGet(API_BASE + "/quotes/" + flg_id)
    if(!response.ok) {
      return null;
    }
    const quote = await response.json()
    return quote;
  }catch(err) {
    console.log("error in APIGetQuotes")
    console.log(err)
    return null
  }

  return {}
}

APIGetQuotes().catch(error => {
  //  error.message; 
  // 'An error has occurred: 404'
  console.log("Error with APIGetQuotes: - " + error.message);
  return {}
})

// Get Solar Optimisers 
// SolarOptimisers
export const APIGetSolarOptimisers = async () => {
  try{     
    const response = await returnGet(API_BASE + "/SolarOptimisers")
    if(!response.ok) {
        return null;
    }
    const oprimisers = await response.json()
    return oprimisers;
  }catch(err) {
    console.log("error in APIGetSolarOptimisers")
    console.log(err)
    return null
  }
}

APIGetSolarOptimisers().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("APIGetSolarOptimisers - " + error.message);
  return {}
});

export const APIGetEVChargers = async () => {
  
  const response = await returnGet(API_BASE + "/evchargers")
  if(!response.ok) {
      return null;
  }
  const evchargers = await response.json()
  return evchargers;
}

APIGetEVChargers().catch(error => {
  console.log("APIGetEVChargers - " + error.message);
  return null;
});

export const APIInverterSearch = async (payload) => {
  if(typeof payload == "undefined") return [];
  if(typeof payload.from == "undefine") return [];
  const response = await fetch(API_BASE + "/inverter_search", {
    method: 'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null  
              },
    body: JSON.stringify({from: payload.from, to: payload.to, hybrid: payload.hybrid, solaredge: payload.solaredge,is3phase: payload.is3phase,prefmanufacturer: payload.prefmanufacturer, offgrid: payload.offgrid })
  })
  if(!response.ok ) return null;

  const inverters = await response.json()
  return inverters
}

APIInverterSearch().catch(error => {
  console.log("APIInverterSearch - " + error.message);
  return null;
});

export const APIGetAllInverters = async () => {
  const response = await fetch(API_BASE + "/inverters", {
    method:   'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null 
              },
  })
  if(!response.ok ) {

      return null;
  }
  const inverters = await response.json()
  return inverters
}

APIGetAllInverters().catch(error => {
  console.log("APIGetAllInverters - " + error.message);
  return null;
});

// Ger Anciallry Costs
export const APIAncillaryCosts = async (payload) => {
  
  const response = await returnGet(API_BASE + "/ancillary")
  if(!response.ok ) {
      return null;
  }
  const ancillary = await response.json()
  return ancillary
}

APIAncillaryCosts().catch(error => {
  console.log("APIAncillaryCosts - " + error.message);
  return null;
});


// Get All Fixed Costs
export const APIFixedCosts = async (payload) => {
  const response = await returnGet(API_BASE + "/fixedcosts")
  if(!response.ok ) return null;

  const fixedcosts = await response.json()
  return fixedcosts
}

APIFixedCosts().catch(error => {
  console.log("APIFixedCosts - " + error.message);
  return null;
});

// Get the Mounting Hardware Map — per-colour rail/clamp/end-stop slots plus per-roof-type hook slots.
// The calculator uses this to turn computed BOM quantities into priced lineitems keyed by ac_id.
export const APIMountingHardwareMap = async () => {
  try {
    const response = await returnGet(API_BASE + "/api/mounting_hardware_map")
    if (!response.ok) return []
    const body = await response.json()
    // Generic /api CRUD controllers wrap their payload as { success, count, total, data }
    return Array.isArray(body?.data) ? body.data : []
  } catch (err) {
    console.log("APIMountingHardwareMap - " + err.message)
    return []
  }
}

// Get every pricing_config row — admin-managed offer discounts, VAT rates,
// commission policy, etc. The calculator hydrates a Map keyed by `key` and
// uses it instead of the legacy hard-coded values in src/configs/pdf_configs.js
// (which still serve as the safety fallback).
export const APIPricingConfig = async () => {
  try {
    const response = await returnGet(API_BASE + "/api/pricing_config")
    if (!response.ok) return []
    const body = await response.json()
    return Array.isArray(body?.data) ? body.data : []
  } catch (err) {
    console.log("APIPricingConfig - " + err.message)
    return []
  }
}

// Get every active product-supplier row for a given product_type (panels/batterys/
// inverters/evchargers/ancillaries). The calc uses this to enrich its catalogue
// arrays with the supplier's unit_cost so lineitems and the BOM job sheet show
// the real cost we pay rather than the legacy (often empty) customer_price field.
export const APIProductSuppliersForType = async (productType) => {
  try {
    const response = await fetch(API_BASE + "/api/product-suppliers/search", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': glob_token ? 'Bearer ' + glob_token : null
      },
      body: JSON.stringify({ product_type: productType, active: true })
    })
    if (!response.ok) return []
    const body = await response.json()
    return Array.isArray(body?.data) ? body.data : []
  } catch (err) {
    console.log("APIProductSuppliersForType(" + productType + ") - " + err.message)
    return []
  }
}


export const APIGetDirections = async (start, end) => {
var arr = [];
var json = null;
    // Check if start and end are the same and if so just return minimal times and distance the same as Google Does
    // Save time on Checking the DB and Google and no point Adding entries to the database either
    // Just time and space wasted.
    if(start == end ) {
        arr["from"] = start;
        arr["to"] = end;
        arr["time"] = "1 min";
        arr["timeval"] = 0;
        arr["distance"] = "1 ft";
        arr["distanceval"] = 0;
        arr["status"] = "Ok";
        return arr;        
    } 
    
    
    // Get the URL for the Drivetime and distance (now uses Node.js endpoint)
    let url = API_BASE + "/directions?start=" + encodeURIComponent(start) + "&end=" + encodeURIComponent(end);


    try {
        json = await axios.get(url, {
            crossdomain: true ,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }});

    } catch (error) {
        console.log(error);
        return [];
    }
    if(typeof(json.data) !== "undefined" && json.data.status == "OK")
    {
        arr["from"] = json.data.from;
        arr["to"] = json.data.to;
        arr["time"] = json.data.time;
        arr["timeval"] = json.data.timeval;
        arr["distance"] = json.data.distance;
        arr["distanceval"] = json.data.distanceval;
        
    }

    return arr
}

APIGetDirections().catch(error => {
  console.log("APIGetDirections - " + error.message);
  return null;
});

// Output Pricing Data From the system
export const APIOutputPricing = async(flg_id,lineitems, full_name, address) => {

    
  if(typeof flg_id === "undefined") return

  if(typeof lineitems === "undefined" || lineitems.length == 0) return; // No Data so return

  await  fetch(API_BASE + "/pricing/" + flg_id , {
    method:   'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null
              },
    body: JSON.stringify({lineitems, full_name, address })
  })
  return
} 

APIOutputPricing().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("Error with APIOutputPricing: - " + error.message);
  return {}
});

// Get All Sites for a Given FLG ID
export const APIGetSites = async (flg_id) => {
  if(typeof flg_id == "undefined") return []

  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()
 // Make sure we are still logged in.  
 var url = `${API_BASE}/sites/${flg_id}`

  const response = await returnGet(url)
  if(!response.ok) {
      return null;
  }
  const sites = await response.json()
  return sites;
}

APIGetSites().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("SitAPIGetSiteses - " + error.message);
  return []
});

//Get Specific site for flg_id and site_id
// Get All Sites for a Given FLG ID
export const APIGetSite = async (flg_id, site_id) => {
  if(typeof flg_id == "undefined") return []
  if(typeof site_id == "undefined") return []

  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()

 // Make sure we are still logged in.  
 var url = `${API_BASE}/site/${flg_id}/${site_id}`

  const response = await returnGet(url)
  if(!response.ok) {
      return null;
  }
  const sites = await response.json()
  return sites;
}

APIGetSite().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("APIGetSite - " + error.message);
  return []
});

// Add / Update a new Site
//app.post('/sites/:flg_id', authCtrl.checktoken, authCtrl.requireSignin, sites.update)
// Get All Sites for a Given FLG ID
export const APIAddUpdateSites = async (flg_id,site_data) => {
  if(typeof site_data == "undefined") return null
  const {site_id, site_name, primarycontact,address,contacts} = site_data
  if((flg_id??-1)  <0) return {status: false, message: 'Invalid flg_id ${flg_id}'}
  if((site_id??-1) <0 ) return {status: false, message: 'Invalid site_id ${site_id}'}
  if(typeof glob_token == "undefined" || glob_token == "")
    await APIloggedin()
 // Make sure we are still logged in.  
 var url = `${API_BASE}/sites/${flg_id}/${site_id}`

  const response = await fetch(url,
  {
    method:   'POST',
    headers:  { 'Content-Type': 'application/json',
                'Authorization': glob_token ? 'Bearer ' + glob_token : null 
              },
    body: JSON.stringify({site_name, primarycontact,address,contacts })
  })
  if(!response.ok) {
    const sites = await response.json()
      return null;
  }
  const sites = await response.json()
  return sites;
}

APIAddUpdateSites().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("APIAddUpdateSites - " + error.message);
  return []
});

export const APIPostcodeSearch = async (postcode) => {
  if(!(postcode??false)) return []

  try {
    let res = await fetch("https://api.ideal-postcodes.co.uk/v1/postcodes/" + postcode + "?api_key=ak_kjlbozsesgFNTZoFNVxu15HKg0ssL");
    var results = []
    var lookups = []
    if(res.ok)
      results = await res.json();
    else {
      return [{paf: results, text: '', index: null, error: res}]
    }


    if((results??false) && results.result && results.result.length > 0){

      for(let i=0; i<results.result.length; i++)
      {
          let strAddr = results.result[i].line_1
          if(results.result[i].line_2) strAddr+= `,${results.result[i].line_2}`
          if(results.result[i].line_3) strAddr+= `,${results.result[i].line_3}`
          if(results.result[i].post_town) strAddr+= `,${results.result[i].post_town}`
          if(results.result[i].postal_county) strAddr+= `,${results.result[i].postal_county}`
          lookups.push({paf: results.result[i], text: strAddr, index: i, error: ''})
      }
      return lookups
    }
    return [{paf: results, text: '', index: null, error: ''}]
  }catch(ex) {
    console.log(ex)
    return [{paf: [], text: '', index: null, error: ex}]
  }
}

APIPostcodeSearch().catch(error => {
  //error.message; // 'An error has occurred: 404'
  console.log("APIPostcodeSearch - " + error.message);
  return [{paf: [], text: '', index: null, error: error}]
});